import { cn } from '@tempo-io/sui-class-utils';
import type { ReactNode } from 'react';
import type { ActualCostCompletenessStatus } from '@/common/api/types/itemFinancials';
import { ActualCostStatusIndicator } from './ActualCostStatusIndicator';

export const ActualCostAmount = ({
  amount,
  status,
  className,
}: {
  amount: ReactNode;
  status: ActualCostCompletenessStatus | null | undefined;
  className?: string;
}) => (
  <span className={cn('inline-flex items-center gap-1.5', className)}>
    <ActualCostStatusIndicator status={status} />
    {amount}
  </span>
);
